<template>
  <b-modal
    centered
    size="xl"
    v-bind="$attrs"
    hide-header
    hide-footer
    body-class="p-0"
    no-close-on-backdrop
    no-close-on-esc
  >
    <slot />
  </b-modal>
</template>

<script>
import { mapActions } from 'vuex';
import * as trackersTypes from '@/modules/trackers/store/types';

export default {
  name: 'TrackerModal',
  props: {
  },
  data() {
    return {
    };
  },
  methods: {
    ...mapActions('trackers', [
      trackersTypes.RESET_IMPORT_TRACKERS,
      trackersTypes.SET_IMPORTING_PLACEMENT_LEVEL_TRACKERS,
    ]),
  },
  computed: {
  },
  mounted() {
    this.$root.$on('bv::modal::hide', (bvEvent, modalId) => {
      if (modalId === 'trackersModal') {
        this.RESET_IMPORT_TRACKERS();
        this.SET_IMPORTING_PLACEMENT_LEVEL_TRACKERS(false);
      }
    });
  },
};
</script>
